<template>
  <modal :title="`[${info.carrierDeviceName}]${$t('public.device')} ${$t('public.details')}`" :visible='detailShow'
         @close='close' width='700px' append-to-body>
    <div>
      <!-- type=1 传感器 -->
      <table class='uk-table uk-table-small uk-margin-top uk-margin-left'>
        <tr v-if="info.deviceCatalog === '2'">
          <td>{{ $t('device.display_number') }}:</td>
          <td>{{ info.name }}</td>
        </tr>

        <tr v-if="info.deviceCatalog === '0' && info.probeValue">
          <td>{{ $t('device.sample_value') }}:</td>
          <td>
                        <span v-if='info.probeValue.temp'>{{ $t('public.temp') }}:
                            <span :class="{
                                'higher-range': info.tempRange && info.probeValue.temp.val > info.tempRange.max,
                                'lower-range': info.tempRange && info.probeValue.temp.val < info.tempRange.min
                            }">
                                {{ info.probeValue.temp.val }}{{ defaultUnit['temp'] }}</span>
                        </span>
            <span class='uk-margin-small-left' v-if='info.probeValue.hum'>
                            {{ $t('public.hum') }}:<span :class="{
                                'higher-range': info.humidityRange && info.probeValue.hum.val > info.humidityRange.max,
                                'lower-range': info.humidityRange && info.probeValue.hum.val < info.humidityRange.min
                            }">{{ info.probeValue.hum.val }}{{ defaultUnit['hum'] }}</span>
                        </span>

            <!-- 如果同时由温湿度 只需要展示其中一个的时间 -->
            <span v-if='info.probeValue.temp'> [{{ $timetransition(info.probeValue.temp.time) }}] </span>
            <span v-else-if='info.probeValue.hum'> [{{ $timetransition(info.probeValue.hum.time) }}] </span>
          </td>
        </tr>
        <tr v-if="info.deviceCatalog === '0' && info.tempRange">
          <td>{{ $t('public.temp_range') }}:</td>
          <td>{{ info.tempRange.name }} ({{ info.tempRange.min }}{{ info.tempRange.unitName }}~{{
              info.tempRange.max }}{{ info.tempRange.unitName }})
          </td>
        </tr>
        <tr v-if="info.deviceCatalog === '0' && info.humidityRange">
          <td>{{ $t('public.hum_range') }}:</td>
          <td>{{ info.humidityRange.name }} ({{ info.humidityRange.min }}{{ info.humidityRange.unitName }}~{{
              info.humidityRange.max }}{{ info.humidityRange.unitName }})
          </td>
        </tr>

        <tr v-if="info.deviceCatalog === '1'">
          <td>{{ $t('device.mac_address') }}:</td>
          <td>{{ info.mac }}</td>
        </tr>
        <tr v-if="info.deviceCatalog === '1' || info.deviceCatalog === '2' || info.eqType === 'relay'">
          <td>{{ $t('public.updateTime') }}:</td>
          <td>{{ $timetransition(info.updateTime) }}</td>
        </tr>
        <tr>
          <td>{{ $t('public.is_abnormal') }}:</td>
          <td>{{ info.abnormalText || (info.abnormal ? $t('public.btn_yes') : $t('public.btn_no')) }}</td>
        </tr>
      </table>
    </div>
    <div slot='footer'>
      <div class='uk-margin-small uk-margin-small-top'>
        <el-button type='primary' @click='close'>{{ $t('buttonTitle.Close') }}</el-button>
      </div>
    </div>
  </modal>
</template>

<script>
import { defaultUnit } from '../../../../../../../utils/convert'

export default {
  computed: {
    defaultUnit () {
      return defaultUnit
    }
  },
  props: ['detailShow', 'info'],
  data () {
    return {}
  },
  methods: {
    close () {
      this.$emit('update:detailShow', false)
    }
  },
  mounted () {
    console.log('info', this.info)
  }
}
</script>

<style></style>
